import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Stack,
  Paper
} from '@mui/material';
import {
  Send
} from '@mui/icons-material';
import MarkdownEditor from '../Common/MarkdownEditor';

function ThreadCreateForm({
  questions = [],
  questionCategoryOptions = [],
  onSubmit,
  onCancel,
  submitting = false,
  initialValues = { title: '', content: '', questionId: '', category: '' }
}) {
  const [formData, setFormData] = useState(initialValues);
  const [questionCategory, setQuestionCategory] = useState('');

  // Reset form when initialValues change
  useEffect(() => {
    setFormData(initialValues);
  }, [initialValues]);

  const handleContentChange = (content) => {
    setFormData((prev) => ({ ...prev, content }));
  };

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit(formData);
    }
  };

  const handleCancel = () => {
    setFormData({ title: '', content: '', questionId: '', category: '' });
    setQuestionCategory('');
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <Paper variant="outlined" sx={{ p: 2, height: '100%', overflow: 'auto' }}>
      <Stack spacing={2}>
        <TextField
          label="专题标签 *"
          select
          required
          fullWidth
          size="small"
          value={formData.category}
          onChange={(e) => setFormData({ ...formData, category: e.target.value })}
          SelectProps={{
            native: true,
            displayEmpty: true,
          }}
          InputLabelProps={{ shrink: true }}
          error={!formData.category}
          helperText={!formData.category ? '请选择专题标签' : ''}
        >
          <option value="">请选择专题</option>
          {questionCategoryOptions.map((cat) => (
            <option key={cat} value={cat}>{cat}</option>
          ))}
        </TextField>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
          <TextField
            label="按专题筛选题目"
            select
            fullWidth
            size="small"
            value={questionCategory}
            onChange={(e) => {
              setQuestionCategory(e.target.value);
              setFormData((prev) => ({ ...prev, questionId: '' }));
            }}
            SelectProps={{
              native: true,
              displayEmpty: true,
            }}
            InputLabelProps={{ shrink: true }}
          >
            <option value="">全部专题</option>
            {questionCategoryOptions.map((cat) => (
              <option key={cat} value={cat}>{cat}</option>
            ))}
          </TextField>
          <TextField
            label="关联题目（可选）"
            select
            fullWidth
            size="small"
            value={formData.questionId}
            onChange={(e) => setFormData({ ...formData, questionId: e.target.value })}
            SelectProps={{
              native: true,
              displayEmpty: true,
            }}
            InputLabelProps={{ shrink: true }}
          >
            <option value="">不关联题目</option>
            {questions
              .filter((q) => !questionCategory || q.category === questionCategory)
              .map((q) => (
                <option key={q._id || q.id} value={q._id || q.id}>
                  {q.category} · {q.questionNumber} - {q.title}
                </option>
              ))}
          </TextField>
        </Stack>
        <TextField
          label="问题标题"
          fullWidth
          size="small"
          value={formData.title}
          onChange={(e) => setFormData({ ...formData, title: e.target.value })}
        />
        <MarkdownEditor
          value={formData.content}
          onChange={handleContentChange}
          label="问题内容"
          minRows={8}
          maxRows={20}
          showPreview={true}
          showToolbar={true}
          placeholder="输入问题内容，可以使用工具栏插入代码、符号和图片..."
          disabled={submitting}
        />
        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button
            variant="outlined"
            onClick={handleCancel}
          >
            取消
          </Button>
          <Button
            variant="contained"
            startIcon={<Send />}
            onClick={handleSubmit}
            disabled={submitting || !formData.title.trim() || !formData.content.trim() || !formData.category}
          >
            {submitting ? '发布中...' : '发布问题'}
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
}

export default ThreadCreateForm;

